module.exports = __webpack_public_path__ + "img/play.ec583e63.png";